import { Controller } from "@hotwired/stimulus"

// Deshabilita el envío mientras el campo de texto enriquecido no tenga texto
// visible: Quill deja "<p><br></p>" (o espacios) aunque se vea vacío. Lo
// escucha el `input` que emite rich-text al sincronizar su hidden.
const INVISIBLES = /[\s ​‌‍﻿]/g

export default class extends Controller {
  static targets = ["boton"]

  connect() {
    this.revisar()
  }

  revisar() {
    const html = this.element.querySelector("[data-rich-text-target='input']")?.value || ""
    const texto = new DOMParser().parseFromString(html, "text/html").body.textContent.replace(INVISIBLES, "")
    this.botonTargets.forEach((boton) => { boton.disabled = texto.length === 0 })
  }
}
